import Vue from "vue";
import App from "./App.vue";
import "./plugins/vuetify";
import router from "./router";
import store from "./store";
var VueCookie = require("vue-cookie");
Vue.use(VueCookie);

import CKEditor from "@ckeditor/ckeditor5-vue2";
Vue.use(CKEditor);

import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

/** High chart config */
import mapData from "@highcharts/map-collection/countries/bd/bd-all.geo.json";
// import topMapData from "@highcharts/map-collection/countries/bd/bd-all.topo.json";
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import HighchartsAccessibility from "highcharts/modules/accessibility";
import HighchartsExportData from "highcharts/modules/export-data";
import HighchartsExporting from "highcharts/modules/exporting";
import mapInit from "highcharts/modules/map";
// import HighchartsOfflineExporting from "highcharts/modules/offline-exporting";

mapInit(Highcharts);

Highcharts.maps["highChartMap"] = mapData;
// Highcharts.maps["highChartMapTopo"] = topMapData;

HighchartsExporting(Highcharts);
HighchartsExportData(Highcharts);
// HighchartsOfflineExporting(Highcharts);
HighchartsAccessibility(Highcharts);

Vue.use(HighchartsVue);

// import * as VueGoogleMaps from "vue2-google-maps"; // Import package

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyBopjfnGCWi5-tGPN3iILP_vevr4CBnUqw",
//     libraries: "places"
//   }
// });

/** High chart end */

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
